import request from "@/utils/request";

function createRequestId() {
  if (!window.crypto || typeof window.crypto.getRandomValues !== "function") {
    throw new Error("Secure random generator is unavailable");
  }

  const bytes = new Uint8Array(16);
  window.crypto.getRandomValues(bytes);
  return Array.prototype.map
    .call(bytes, (value) => (value + 0x100).toString(16).slice(1))
    .join("");
}

export default {
  createWithdrawalRequestId() {
    return createRequestId();
  },
  // 积分日志
  quantityLogList(begin_date, end_date, type) {
    if (type != undefined) {
      return request.post("/api/user/quantityLogList", {
        begin_date: begin_date,
        end_date: end_date,
        type: type,
      });
    } else {
      return request.post("/api/user/quantityLogList", {
        begin_date: begin_date,
        end_date: end_date,
      });
    }
  },
  orderList(begin_date, end_date) {
    return request.post("/api/user/orderList", {
      begin_date: begin_date,
      end_date: end_date,
    });
  },
  //   个人中心
  userInfo() {
    return request.post("/api/user/userInfo");
  },
  //   收款信息
  payInfo(type) {
    return request.post("/api/user/payInfo", {
      type: type,
    });
  },
  //   收款信息更新
  setPayInfo(acc, acc_name, acc_bank, mark, type) {
    return request.post("/api/user/setPayInfo", {
      acc: acc,
      acc_name: acc_name,
      acc_bank: acc_bank,
      mark: mark || "",
      type: type,
    });
  },
  //   安全码
  safetyInfo() {
    return request.post("/api/user/safetyInfo", {});
  },
  //   安全码更新
  setSafety(new_code, after_code) {
    return request.post("/api/user/setSafety", {
      new_code: new_code,
      after_code: after_code,
    });
  },
  //   密码更新
  newPass(new_pass, after_pass) {
    return request.post("/api/user/newPass", {
      new_pass: new_pass,
      after_pass: after_pass,
    });
  },
  //   提现页面
  withdrawInfo() {
    return request.post("/api/user/withdrawInfo", {});
  },
  //   提现请求
  withdrawAction(type, money, securityCode, requestId) {
    const stableRequestId = requestId || createRequestId();
    return request.post("/api/user/withdrawAction", {
      type: type,
      money: money,
      securityCode: securityCode,
      request_id: stableRequestId,
    }, {
      // 超时重试会复用同一个请求体和request_id。
      idempotent: true,
    });
  },
  //   充值页面
  recharge() {
    return request.post("/api/user/recharge", {});
  },
    //   充值页面
    profile(nickname, idcard) {
      return request.post("/api/user/profile", {
        nickname: nickname || "",
        idcard: idcard || "",
      });
    },
};
